import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import "@/polyfills";

import { createBrowserRouter } from "react-router-dom";
import { RouterProvider } from "react-router-dom";
import { routes } from "@/router/routes";
import SuspenseFallback from "@/components/layout/SuspenseFallback";

import "@/main.css";
import { ThemeProvider } from "@/contexts/Theme";

import { ReactQueryProvider } from "@/contexts/ReactQuery";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "@/translations/i18n";
import { AuthProvider } from "./contexts/Auth";
import { Toaster } from "@/components/ui/sonner";

import { ConnectToStoreProvider } from "@/contexts/ConnectToStoreProvider"; 
import ConnectToStoreModal from "@/components/workspace/ConnectToStoreModal";
const router = createBrowserRouter(routes);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ReactQueryProvider>
    <ConnectToStoreProvider>
      <AuthProvider>
        <ThemeProvider>
          <Suspense fallback={<SuspenseFallback />}>
            <RouterProvider router={router} />
            <Toaster />
            <ConnectToStoreModal />
          </Suspense>
          <ReactQueryDevtools initialIsOpen={false} />
        </ThemeProvider>
        </AuthProvider>
      </ConnectToStoreProvider>
    </ReactQueryProvider>
  </React.StrictMode>
);
